export const primary = '#850009'
export const secondary = '#222'
export const gray = '#999'
export const lightGray = '#ddd'
export const lighterGray = '#efefef'
export const green = '#8BC34A'
export const red = '#B71C1C'



// WEBPACK FOOTER //
// ./src/config/colors.js